  
import EnterPin, { epaction, eploader } from './pin';

import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';

import af from './style.module.scss';

function Send() {
  return (
    <div>
      <div className={af.body}>
        <Outlet />
      </div>
    </div>
  );
} 

export const accesspinroutes = {
  path: `onetime`, 
  element: <Send />,
  children: [
    { index: true, 
      element: <EnterPin />,
      action: epaction,
      loader: eploader, },
    {
      path: 'pin',
      element: <EnterPin />,
      action: epaction,
      loader: eploader,
    },
  ],
};
